<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="position-relative grid-content" style="margin-top: 10px;">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()" *ngIf="showFindingAddBtn">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="Add Audit Findings" />
          <span class="reload_text text-white">Add Audit Findings</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div>
          <span class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReorderPopup()" (keydown.enter)="openReorderPopup()" matTooltip="Reorder"
            *ngIf="auFindingsDataForGrid?.length > 1">
            <img src="../../../assets/img/reorder.svg" width="18px" height="18px" alt="reorder" />
            <span class="reload_text text-white">Reorder</span>
          </span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container" aria-describedby="table-description">
      <th style="min-width: 60px; text-align: center;background: white;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
        </div>
      </th>
      <th id="grid-header-container" (focus)="focusEmpty()"
        *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
        class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div class="sort" (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
              (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
              <div><i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='asc'"
                  class='fas fa-angle-up' style='font-size:11px'></i></div>
              <div><i
                  *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='desc'"
                  class='fas fa-angle-down' style='font-size:11px'></i></div>
              <img *ngIf="sortedDisplayColumn!=oneQmsUsersDataForTable1Data.fieldColumnarray"
                src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
          </div>
        </div>
      </th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr>
        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
          (focus)="focusEmpty()"
          [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
          class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
        </td>
      </tr>
      <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
        [class.highlightRow]="list.childCheckBoxs == true">
        <td style="min-width: 60px; text-align: center;background: white;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" (focus)="focusEmpty()"
          [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
          (mouseover)="cssfunction(i)" (click)="detailsData(list,i)" (keydown.enter)="detailsData(list,i)">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                height="20">
              <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                width="20" height="20">
            </div>
          </span>
          <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]!='htmlClobView'">{{ removeHtmlTags(list[key.columnsListarray])
              }}</span>
          </span>
          <span *ngIf="key.dataType=='DATE'">
            {{ list[key.columnsListarray]}}
          </span>
        </td>
        <td class="sticky-col first-col">
        </td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
              style="margin-left: 5px;" (click)="openAuditTrail('individual',list)"
              (keydown.enter)="openAuditTrail('individual',list)"></i>
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="col-sm-12 action-buttons-container" style="padding-right: 2%;" *ngIf="operationFlag == 'EDIT'">
      <span class="crDetail-status1" [ngStyle]="{'color':getColor(findingsData.status) , 'zoom':'1.3'}">
        Status&nbsp;:&nbsp;
        <span>{{this.findingsData.status}}</span>
      </span>&nbsp;&nbsp;
    </div>

    <div class="findings">

      <div class="row field-row-up">
        <div class="col-md-6">
          <div class="row">
            <label id="finding-short-description-validation"
              for="email">{{dynamicLabel['FINDING_SHORT_DESCRIPTION'].fieldName}}
              <span class="mandatory-symbol">*</span>
            </label>
            <span class="info-icon" *ngIf="dynamicLabel['FINDING_SHORT_DESCRIPTION']?.fieldNotes"
              [matTooltip]="dynamicLabel['FINDING_SHORT_DESCRIPTION']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class=" col-sm-12">
              <input class="form-control" type="text" [(ngModel)]="findingsData.findingShortDescription"
                (ngModelChange)="onNgModelChange(findingsData.findingShortDescription, 'finding-short-description-validation')">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label id="finding-validation" for="email">{{dynamicLabel['FINDING'].fieldName}}<span
                class="mandatory-symbol">*</span>
            </label>
            <span class="info-icon" *ngIf="dynamicLabel['FINDING']?.fieldNotes"
              [matTooltip]="dynamicLabel['FINDING']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="findingsData.finding" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"
                (ngModelChange)="onNgModelChange(findingsData.finding, 'finding-validation')"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Finding')"
              (keydown.enter)="openEditor('Finding')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>

        <ng-container *ngIf="dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y'">
          <div class="col-md-6">
            <div>
              <label id="requested-at" for="email">
                {{dynamicLabel['REQUESTED_AT']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <mat-select matInput placeholder="Select" [(ngModel)]="findingsData.requestedAt"
              (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
              (keydown.enter)="focusSearch('focus-requested-at')"
              [ngClass]="{'odd-item-mat-select': isRequestedAtOdd == findingsData.requestedAt}">
              <input type="search" id="focus-requested-at" class="dropdownsearchstyle"
                [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" (onSelectionChange)="onRequestedAtSelect($event, null)"
                [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of requestedAtDropdown| assessmentSearch :requestedAtSearchText"
                (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>

          <div class="col-md-6" *ngIf="findingsData.requestedAt">
            <div>
              <label id="business-area" for="email">
                {{((findingsData.requestedAt ?? ' ') + ' ' + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
              </label> <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput multiple placeholder="Select" #businessArea [(ngModel)]="selectedBusinessArea"
              *ngIf="businessAreaDropdown.length" (closed)="businessAreaSearchText=''" [matTooltip]="getTooltip()"
              (click)="focusSearch('focus-b-area')" (keydown.enter)="focusSearch('focus-b-area')">
              <input type="search" id="focus-b-area" class="dropdownsearchstyle" [(ngModel)]="businessAreaSearchText"
                matInput placeholder="search">
              <div class="select-all">
                <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected" (change)="toggleAllBusinessArea()">Select
                  All</mat-checkbox>
              </div>
              <mat-option
                *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                {{ item1.displayExp }}
              </mat-option>
            </mat-select>
            <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="!businessAreaDropdown.length"
              [(ngModel)]="findingsData.coreBusinessAreaName"
              (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
          </div>
        </ng-container>

      </div>

      <div class="row field-row-up">
        <div class="col-md-6" [hidden]="dynamicLabel['REFERENCE']?.isRemovable == 'Y'">
          <div class="row">
            <label id="reference-validation" for="email">{{dynamicLabel['REFERENCE'].fieldName}} <span
                class="mandatory-symbol">*</span></label>
            <span class="info-icon" *ngIf="dynamicLabel['REFERENCE']?.fieldNotes"
              [matTooltip]="dynamicLabel['REFERENCE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="findingsData.reference" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Reference')"
              (keydown.enter)="openEditor('Reference')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6" [hidden]="dynamicLabel['DELIVERABLES']?.isRemovable == 'Y'">
          <div class="row"><label id="deliverables-validation"
              for="email">{{dynamicLabel['DELIVERABLES'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['DELIVERABLES']?.fieldNotes"
              [matTooltip]="dynamicLabel['DELIVERABLES']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="findingsData.deliverables" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Deliverables')"
              (keydown.enter)="openEditor('Deliverables')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>

      </div>

      <div class="row field-row-up">
        <div class="col-md-6" [hidden]="dynamicLabel['AUDITOR_COMMENTS']?.isRemovable == 'Y'">
          <div class="row">
            <label for="email">{{dynamicLabel['AUDITOR_COMMENTS'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['AUDITOR_COMMENTS']?.fieldNotes"
              [matTooltip]="dynamicLabel['AUDITOR_COMMENTS']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="findingsData.auditorComments" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Auditor Comments')"
              (keydown.enter)="openEditor('Auditor Comments')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="field-row-down">
            <label id="severity-validation" for="email">{{dynamicLabel['SEVERITY'].fieldName}}</label> <span
              class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['SEVERITY']?.fieldNotes"
              [matTooltip]="dynamicLabel['SEVERITY']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedSeverity" (closed)="severityTxt=''"
            (click)="focusSearch('severitySearch')" (keydown.enter)="focusSearch('severitySearch')"
            [ngClass]="{'odd-item-mat-select':isSeverityOdd==selectedSeverity}">
            <input type="search" id="severitySearch" class="dropdownsearchstyle" [(ngModel)]="severityTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of severityDropdown| assessmentSearch :severityTxt"
              (onSelectionChange)="onSeveritySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-3">
          <div class="field-row-down">
            <label for="ex-closure-date" id="expectedClosureDate-validation">
              {{dynamicLabel['EXPECTED_CLOSURE_DATE'].fieldName}}
            </label>
            <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_CLOSURE_DATE']?.fieldNotes"
              [matTooltip]="dynamicLabel['EXPECTED_CLOSURE_DATE']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <input type="text" class="form-control data-picker-continer" [disabled]="closureDateDisableFlag" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="findingsData.expectedClosureDate">
        </div>
        <div class="col-md-6" [hidden]="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.isRemovable == 'Y'">
          <div class="field-row-down">
            <label id="responsibilityUserDetails-validation"
              for="email">{{dynamicLabel['ASSIGNED_TO_USER_DETAILS'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.fieldNotes"
              [matTooltip]="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="findingsData.assignedToUserDetails" [config]="config" [spellcheck]="true"
                (paste)="onPaste($event)"></st-editor>
            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Assigned To User Details')"
              (keydown.enter)="openEditor('Assigned To User Details')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="field-row-down">
            <label id="assign-to-user-validation" for="email">{{dynamicLabel['ASSIGNED_TO'].fieldName}}</label> <span
              class="mandatory-symbol">*</span>
            <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO']?.fieldNotes"
              [matTooltip]="dynamicLabel['ASSIGNED_TO']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAssignedToUser" (closed)="assignedToUserTxt=''"
            (click)="focusSearch('assignedToUserSearch')" (keydown.enter)="focusSearch('assignedToUserSearch')"
            [ngClass]="{'odd-item-mat-select':isassignedToUserOdd==selectedAssignedToUser}">
            <input type="search" id="assignedToUserSearch" class="dropdownsearchstyle" [(ngModel)]="assignedToUserTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of assignedToUserDropDown| assessmentSearch :assignedToUserTxt"
              (onSelectionChange)="onAssignToUserSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

          <div><label for="email">{{dynamicLabel['IS_CAPA_REQUIRED'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['IS_CAPA_REQUIRED']?.fieldNotes"
              [matTooltip]="dynamicLabel['IS_CAPA_REQUIRED']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-slide-toggle color="primary" name="isPrimaryProduct" [(ngModel)]="findingsData.isCapaRequired"
            (change)="onIsCAPARequiredChange($event)">
            <ng-container *ngIf="findingsData.isCapaRequired; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <div class="field-row-down"><label for="email">{{dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldName}}</label>
            <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO_DEPARTMENT']?.fieldNotes"
              [matTooltip]="dynamicLabel['ASSIGNED_TO_DEPARTMENT']?.fieldNotes">
              <img [src]="infoIconSrc" alt="note" width="18" height="18">
            </span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAssignedToDepartment"
            (closed)="assignedToDepartmentTxt=''" (click)="focusSearch('assignedToDepartmentSearch')"
            (keydown.enter)="focusSearch('assignedToDepartmentSearch')"
            [ngClass]="{'odd-item-mat-select':isassignedToDepartmentOdd==selectedAssignedToDepartment}">
            <input type="search" id="assignedToDepartmentSearch" class="dropdownsearchstyle"
              [(ngModel)]="assignedToDepartmentTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch :assignedToDepartmentTxt"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>

          <div id="search-container"
            *ngIf="findingsData.isCapaRequired && (findingsData.capaNo==null||findingsData.capaNo==undefined)">
            <div><label id="capaActivity-validation" for="email">CAPA Activity</label></div>
            <span class="fa fa-search form-control-feedback" (click)="openSearchCapaRequiredPopup()"
              (keydown.enter)="openSearchCapaRequiredPopup()"></span>
            <input class="form-control" type="text" [(ngModel)]="findingsData.capaNo" placeholder="Search"
              [disabled]="(findingsData.isCapaRequired)">
          </div>
          <div class="inner-align" *ngIf="findingsData.capaDetails">
            <div><label for="email ">{{dynamicLabel['CAPA_DETAILS'].fieldName}}</label>
              <span class="info-icon" *ngIf="dynamicLabel['CAPA_DETAILS']?.fieldNotes"
                [matTooltip]="dynamicLabel['CAPA_DETAILS']?.fieldNotes">
                <img [src]="infoIconSrc" alt="note" width="18" height="18">
              </span>
            </div>
            <input class="form-control" type="text" [(ngModel)]="findingsData.capaDetails"
              [matTooltip]="findingsData.capaDetails" [disabled]="true">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="btn-align">
    <div class="button-continer" *ngFor="let button of buttonList" style="margin-left: 10px;">
      <button *ngIf="button == 'Cancel'" mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
        {{button}}
      </button>
      <button *ngIf="button == 'Save'" mat-stroked-button class="addButton" (click)="addAndEditFunction(findingsData)">
        Add
      </button>
      <button *ngIf="button != 'Cancel' && button != '' && button != 'Save'" mat-stroked-button class="addButton"
        (click)="dynamicButtonClick(button)"> {{button}}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="row"></div>
      <div class="col-sm-12"><st-editor [(ngModel)]="editorValue" [config]="config1" [spellcheck]="true"
          (paste)="onPaste($event)"></st-editor>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label id="delete-reason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="findingsData.deleteReason"
            (ngModelChange)="onNgModelChange(findingsData.deleteReason, 'delete-reason-validation')"></textarea>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="deleteFunction(findingsData)" (keydown.enter)="deleteFunction(findingsData)">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-sm-12"
          *ngIf="buttonLabel=='Review'||buttonLabel==='Approve'||buttonLabel=='Verify Response'||buttonLabel==='Verify Implementation'">
          <div><label id="reviewAndapprove-validation" for="email">{{buttonLabel}}</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status"
              (change)="radioChange($event)">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-md-12 fieldStyle3" *ngIf="isEsignRequired">
          <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
          <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled></div>
        </div>
        <div class="col-md-12" *ngIf="isEsignRequired">
          <div class=""><label id="password-validation" for="pass ">Password</label><span
              class="mandatory-symbol">*</span></div>
          <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
              ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
              (focusout)="onPasswordFieldFocusout()" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
        </div>
        <div class="col-md-12" *ngIf="this.buttonLabel=='Review' || this.buttonLabel=='Approve'||this.buttonLabel=='Reject Response'|| this.buttonLabel=='Accept Response'
        ||this.buttonLabel=='Reject Implementation'|| this.buttonLabel=='Accept Implementation'">
          <div><label id="reason-validation" for="reason"> Comments</label><span class="mandatory-symbol">*</span></div>
          <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"></textarea>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button *ngIf="buttonLabel != 'Defer Action'" mat-stroked-button class="addButton"
        (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>
<ng-template #reorderGridPopup>
  <button class="close close-button" (click)="cancelReorder()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="name" class="popupTitle">Findings Reorder</label>
    <label for="name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>

  <div style="margin: 15px 15px;">
    <b class="align-center">Drag and drop to reorder Findings</b>

    <div class="table-container">
      <table style="max-height: 65vh;">
        <thead>
          <th style="width:140px;text-align:center">Current Seq.</th>
          <th style="width:280px;text-align:left">Finding</th>
          <th style="width:140px;text-align:center">New Seq.</th>
        </thead>

        <tbody cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
          <tr cdkDrag cdkDragLockAxis="y" *ngFor="let row of grid; let i = index">
            <td style="text-align:center">{{ row.SEQ }}</td>
            <td>{{ row.FINDING_SHORT_DESCRIPTION || row.findingShortDescription }}</td>
            <td style="text-align:center">{{ row.NEW_ORDER }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" [disabled]="!isReordered" (click)="reorderFindings()">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorder()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>



<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-editor #clobViewPopup></app-editor>

<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-add-map-capa [findings]="findingInfo" (valueEmitter)="onCapaEmitted()"></app-add-map-capa>